import type { Dictionary } from './en'

/** Bangla dictionary. Typed against `Dictionary`, so a missing key fails the build. */
export const bn: Dictionary = {
  common: {
    momonos: 'মোমোনোস',
    back: 'পেছনে',
    next: 'পরবর্তী',
    cancel: 'বাতিল',
    confirm: 'নিশ্চিত করুন',
    close: 'বন্ধ করুন',
    done: 'সম্পন্ন',
    retry: 'আবার চেষ্টা করুন',
    loading: 'লোড হচ্ছে…',
    search: 'খুঁজুন',
    total: 'সর্বমোট',
    subtotal: 'উপমোট',
    vat: 'ভ্যাট',
    discount: 'ছাড়',
    quantity: 'পরিমাণ',
    calories: 'ক্যালরি',
    veg: 'ভেজ',
    bestseller: 'বেস্টসেলার',
    soldOut: 'শেষ হয়ে গেছে',
    offline: 'সংযোগ বিচ্ছিন্ন — আবার যুক্ত হচ্ছে…',
  },
  kiosk: {
    tapToStart: 'অর্ডার করতে স্পর্শ করুন',
    welcome: 'মোমোনোসে স্বাগতম',
    chooseLanguage: 'আপনার ভাষা বেছে নিন',
    startOrder: 'অর্ডার শুরু করুন',
    dineIn: 'এখানে খাব',
    takeaway: 'পার্সেল',
    howToEat: 'কোথায় খাবেন?',
    addToCart: 'কার্টে যোগ করুন',
    yourOrder: 'আপনার অর্ডার',
    emptyCart: 'আপনার কার্ট খালি',
    checkout: 'চেকআউট',
    promoCode: 'প্রোমো কোড',
    apply: 'প্রয়োগ করুন',
    payNow: 'পেমেন্ট করুন',
    stillThere: 'আপনি কি আছেন?',
    idleWarning: 'আপনার অর্ডার {seconds} সেকেন্ডে রিসেট হবে',
    continueOrdering: 'অর্ডার চালিয়ে যান',
    startOver: 'নতুন করে শুরু করুন',
  },
  customize: {
    title: 'কাস্টমাইজ করুন',
    spiceLevel: 'ঝালের মাত্রা',
    spice0: 'ঝাল ছাড়া',
    spice1: 'অল্প ঝাল',
    spice2: 'মাঝারি ঝাল',
    spice3: 'বেশি ঝাল',
    sauces: 'সস',
    extras: 'অতিরিক্ত',
    specialNote: 'বিশেষ নির্দেশনা',
    notePlaceholder: 'যেমন: পেঁয়াজ ছাড়া',
  },
  payment: {
    choose: 'কীভাবে পেমেন্ট করবেন?',
    cash: 'নগদ টাকা',
    bkash: 'বিকাশ',
    nagad: 'নগদ',
    rocket: 'রকেট',
    card: 'কার্ড',
    payAtCounter: 'কাউন্টারে পেমেন্ট করুন',
    payAtCounterHelp: 'পেমেন্ট ও খাবার নিতে কাউন্টারে এই অর্ডার নম্বরটি দেখান।',
    processing: 'প্রসেস হচ্ছে…',
  },
  orderStatus: {
    yourNumber: 'আপনার অর্ডার নম্বর',
    estimatedWait: 'আনুমানিক অপেক্ষা',
    minutes: '{count} মিনিট',
    received: 'অর্ডার গৃহীত হয়েছে',
    preparing: 'আপনার খাবার তৈরি হচ্ছে',
    ready: 'খাবার প্রস্তুত!',
    delivered: 'উপভোগ করুন',
    thankYou: 'ধন্যবাদ!',
    scanToTrack: 'অর্ডার ট্র্যাক করতে স্ক্যান করুন',
  },
  tv: {
    preparing: 'তৈরি হচ্ছে',
    ready: 'প্রস্তুত',
    collectNow: 'সংগ্রহ করুন',
  },
  qr: {
    tableLabel: 'টেবিল {table}',
    yourName: 'আপনার নাম',
    yourPhone: 'ফোন (ঐচ্ছিক)',
    phoneHelp: 'শুধুমাত্র এই অর্ডারের জন্য আপনাকে জানাতে ব্যবহার করা হবে।',
    placeOrder: 'অর্ডার করুন',
    orderPlaced: 'অর্ডার সম্পন্ন',
  },
  errors: {
    VALIDATION_FAILED: 'আপনার অর্ডারটি দেখে আবার চেষ্টা করুন।',
    ITEM_UNAVAILABLE: 'দুঃখিত, আপনার কার্টের একটি আইটেম শেষ হয়ে গেছে।',
    PRICE_CHANGED: 'দাম পরিবর্তন হয়েছে। অনুগ্রহ করে অর্ডারটি দেখে নিন।',
    COUPON_INVALID: 'এই প্রোমো কোডটি সঠিক নয়।',
    COUPON_EXPIRED: 'এই প্রোমো কোডের মেয়াদ শেষ।',
    COUPON_MIN_ORDER: 'এই প্রোমো কোডের জন্য আপনার অর্ডার সর্বনিম্ন পরিমাণের কম।',
    COUPON_EXHAUSTED: 'এই প্রোমো কোডটি সম্পূর্ণ ব্যবহৃত হয়ে গেছে।',
    RATE_LIMITED: 'অনেকবার চেষ্টা করা হয়েছে। একটু অপেক্ষা করুন।',
    SPIN_NOT_ELIGIBLE: 'এই নম্বরটি সম্প্রতি খেলেছে। শীঘ্রই আবার আসুন!',
    INTERNAL: 'কিছু একটা সমস্যা হয়েছে। অনুগ্রহ করে আমাদের স্টাফকে জানান।',
    NETWORK: 'সংযোগ নেই। আবার চেষ্টা করুন।',
  },
}
